import React from 'react';

import fffmagazine from '../assets/images/fff/fff-magazine.png';

const FFFMagazine = ({ isVisible }) => {
    const animation = isVisible ? 'animated-1' : '';
    const animation1 = isVisible ? 'animated-3' : '';
    const animation2 = isVisible ? 'animated-4' : '';

    return (
      <div className="portfolio container reverse">
        <div className={"showcase_desc no-opacity " + animation1}>
          <h2>FabFitFun Magazine</h2>
          <p>Re-designed FabFitFun magazine from scratch. Increased users by 32.35%, Page views by 45.59%, and Avg time on page by 9.14%</p>
          <h3><a href="https://fabfitfun.com/magazine/" target="_blank" rel="noopener noreferrer" id="fff_magazine_website">FabFitFun.com/magazine/</a></h3>
          <p className="my-role">My Role: Design & Project management</p>
          <p className="year-completed">Year of Completion: 2018</p>
          <p><a className="cta-btn" href="https://medium.com/@ohsik/design-process-51dac6c91659" target="_blank" rel="noopener noreferrer" id="fff_magazine_more_cta">Read story</a></p>
        </div>
        <div className="showcase_wrap">
          <div className="project">
            <img src={fffmagazine} alt="FabFitFun Magazine" className={"no-opacity " + animation} />
          </div>
          <div className="project_bg">
            <svg viewBox="0 0 1900 1900" className={"svg_bg no-opacity " + animation2} xmlns="http://www.w3.org/2000/svg">
              <path d="M1863.81926,1194.03476 C1833.02518,1468.37079 1602.66767,1610.70231 1359.38246,1638.77911 C1328.97287,1642.28978 1298.35822,1644.01521 1267.91446,1643.98959 C1210.12856,1656.53745 1150.31764,1647.99568 1086.43957,1662.04689 C1065.89024,1666.24944 1045.15294,1669.80282 1024.27038,1672.68994 C919.857594,1687.12553 811.796339,1684.91321 706.007899,1665.07922 C424.042104,1613.8286 193.342817,1442.99319 82.2653823,1195.28186 C-78.8567086,858.496939 -1.43573682,421.294971 298.105926,210.595125 C323.072716,193.041787 349.577501,177.051593 377.620281,162.829546 C492.397448,67.7681847 637.652555,33.6011037 775.320218,8.50538278 C802.243679,4.62741909 829.414929,2.08197156 856.680167,0.860498417 C883.945405,-0.369516497 911.304631,-0.275557025 938.621136,1.10820975 C965.929096,2.5005183 993.177245,5.17409239 1020.23742,9.09476493 C1269.93949,16.5175633 1534.81645,59.2264144 1705.70481,264.2289 C1902.22642,511.940237 1953.49293,845.069276 1877.30236,1132.2863 C1872.31242,1151.09528 1866.92943,1171.33927 1863.81926,1194.03476" fill="#e14444">
              </path>
            </svg>
          </div>
        </div>
      </div>
    )
}

export default FFFMagazine



// WEBPACK FOOTER //
// ./src/components/FFFMagazine.js